import { CourseLevelEnum } from "../enums/courseLevelEnum";

export interface EssayQuestionRequest {
  question1: string | null;
  question2: string | null;
  question3: string | null;
  question4: string | null;
  question5: string | null;
  question1WordLimit?: number | null;
  question2WordLimit?: number | null;
  question3WordLimit?: number | null;
  question4WordLimit?: number | null;
  question5WordLimit?: number | null;
  courseLevel: CourseLevelEnum;
  courseName: string | null;
}


export enum pilotType {
  common,
  specific,
  recommendation,
  activities
}
